/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExperimentsDataDTO
 */
export interface ExperimentsDataDTO {
    /**
     * 
     * @type {number}
     * @memberof ExperimentsDataDTO
     */
    count?: number;
}

/**
 * Check if a given object implements the ExperimentsDataDTO interface.
 */
export function instanceOfExperimentsDataDTO(value: object): value is ExperimentsDataDTO {
    return true;
}

export function ExperimentsDataDTOFromJSON(json: any): ExperimentsDataDTO {
    return ExperimentsDataDTOFromJSONTyped(json, false);
}

export function ExperimentsDataDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperimentsDataDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function ExperimentsDataDTOToJSON(value?: ExperimentsDataDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
    };
}

